import React from 'react';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Box } from '@mui/system';
import ConfirmationDialog from 'src/components/modal/confirm_dialog';
import { useAppDispatch } from 'src/redux_store';
import { deleteMultipleData, getData } from 'src/redux_store/data/data_actions';
import { toastMessage } from 'src/utils/toast';
import { closeModal } from 'src/redux_store/common/modal_slice';
import { useAppSelector } from 'src/hooks';

interface IProps {
  modalId: string;
  payload: {
    bucketId: string;
    dataId: string;
  }[];
  stationId: string;
  callback: () => void;
}

const ModalDeleteMultipleData = ({ modalId, stationId, payload, callback }: IProps) => {
  const dispatch = useAppDispatch();
  const { payloadData } = useAppSelector((state) => state.dataSlice);

  const handleDelete = () => {
    dispatch(deleteMultipleData({ data: payload, stationId }))
      .unwrap()
      .then(() => {
        toastMessage.success('Xóa thành công');
        dispatch(getData(payloadData));
        handleClose();
        callback();
      })
      .catch((e) => {
        toastMessage.error(e?.message || 'Xóa thất bại');
      });
  };

  const handleClose = () => {
    dispatch(closeModal({ modalId }));
  };

  return (
    <Box>
      <ConfirmationDialog
        modalId={modalId}
        functionName="deleteData"
        sliceName="news"
        describe={`Bạn có muốn xóa ${payload.length} dữ liệu này không ?`}
        callback={handleDelete}
        icon={<WarningAmberOutlinedIcon sx={{ color: '#ff0000' }} />}
        okLabel="Xác nhận"
        cancelLabel="Hủy"
      ></ConfirmationDialog>
    </Box>
  );
};

export default ModalDeleteMultipleData;
